var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "main-content" }, [
    _c("div", { staticClass: "card" }, [
      _c(
        "div",
        { staticClass: "card-body" },
        [
          _c("pulse-loader", {
            staticStyle: { "text-align": "center" },
            attrs: {
              loading: _vm.loading,
              color: _vm.$constants.LOADING_COLOR,
            },
          }),
          _vm._v(" "),
          !_vm.loading && _vm.records.length
            ? [
                _c(
                  "table",
                  { staticClass: "table mt-1 table-sm table-hover" },
                  [
                    _vm._m(0),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      _vm._l(_vm.records, function (s, i) {
                        return _c("tr", [
                          _c("td", [_vm._v(_vm._s(i + 1))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(s.index))]),
                          _vm._v(" "),
                          _c(
                            "td",
                            [
                              !_vm.regions[s.index] && s.index !== "no_index"
                                ? [
                                    _c(
                                      "button",
                                      {
                                        staticClass: "btn btn-xs btn-default",
                                        on: {
                                          click: function ($event) {
                                            return _vm.getRegionName(s.index)
                                          },
                                        },
                                      },
                                      [_vm._v("загрузить")]
                                    ),
                                  ]
                                : [_vm._v(_vm._s(_vm.regions[s.index]))],
                            ],
                            2
                          ),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(s.orders))]),
                          _vm._v(" "),
                          _c("td", [_vm._v(_vm._s(s.totalSum))]),
                        ])
                      }),
                      0
                    ),
                  ]
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("thead", [
      _c("tr", [
        _c("th"),
        _vm._v(" "),
        _c("th", [_vm._v("Индекс")]),
        _vm._v(" "),
        _c("th", [_vm._v("Город")]),
        _vm._v(" "),
        _c("th", [_vm._v("Кол. Заявок")]),
        _vm._v(" "),
        _c("th", [_vm._v("На сумму")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }